<div
  class="flex items-center gap-2 py-2 px-3 rounded-full w-fit bg-shikenso-gray-base cursor-pointer select-none hover:bg-shikenso-gray-base-60 active:bg-shikenso-purple-base-12"
  [class.opacity-50]="disabled()"
  [class.cursor-not-allowed]="disabled()"
  [class.pointer-events-none]="disabled()"
  (click)="onToggle()"
>
  <app-status-badge [status]="status()" [colorScheme]="colorScheme()" />

  @if (selected()) {
    <app-icon src="icons/circle-check.svg" alt="check" color="var(--shikenso-success-bright)" [size]="24" />
  } @else {
    <app-icon src="icons/circle.svg" alt="circle" [size]="24" />
  }
</div>
